import { Controller } from "@hotwired/stimulus";
import { show, showBlock, hide } from '../../../utils';
import { setupTooltips } from "../../../bootstrap";


// RentVerification Financial Damages Form controller
export default class extends Controller {

  connect() {
    this.evictionFiled = this.element.querySelector('#rent_verification_eviction_filed');
    this.evictionContextDiv = this.element.querySelector('#eviction-context-div');
    this.evictionContext = this.element.querySelector('#rent_verification_eviction_note');
    this.evictionJudgment = this.element.querySelector('#rent_verification_eviction_filed');
    this.evictionJudgmentDateDiv = this.element.querySelector('#eviction-judgment-date-div');
    this.balanceOwed = this.element.querySelector('#rent_verification_balance_past_due');
    this.balanceOwedNoteDiv = this.element.querySelector('#balance-owed-note-div');
    this.balanceOwedNote = this.element.querySelector('#rent_verification_balance_past_due_note');
    this.propertyDamage = this.element.querySelector('#rent_verification_property_damage');
    this.propertyDamageNoteDiv = this.element.querySelector('#property-damage-note-div');
    this.propertyDamageNote = this.element.querySelector('#rent_verification_property_damage_note');

    this.evictionFiled?.addEventListener("change", this.evictionFiledEventListener.bind(this));
    this.evictionJudgment?.addEventListener("change", this.evictionJudgmentEventListener.bind(this));
    this.balanceOwed?.addEventListener("input", this.balanceOwedEventListener.bind(this));
    this.propertyDamage?.addEventListener("change", this.propertyDamageEventListener.bind(this));
    this.syncFormWithEvictionFiled();
    this.syncFormWithBalanceOwed();
    this.syncFormWithPropertyDamage();
    this.syncFormWithEvictionJudgment();
    setupTooltips();
  }

  evictionFiledEventListener(e) {
    this.syncFormWithEvictionFiled();
  }

  evictionJudgmentEventListener(e) {
    this.syncFormWithEvictionJudgment();
  }

  balanceOwedEventListener() {
    this.syncFormWithBalanceOwed();
  }

  propertyDamageEventListener() {
    this.syncFormWithPropertyDamage();
  }

  syncFormWithBalanceOwed() {
    if (!this.balanceOwed) return

    let value = this.balanceOwed.value;
    if (!this.balanceOwedNote) return

    if (value > 0) {
      showBlock(this.balanceOwedNoteDiv);
      this.balanceOwedNote.required = true;

    } else {
      hide(this.balanceOwedNoteDiv);
      this.balanceOwedNote.required = false;
    }
  }

  syncFormWithPropertyDamage() {
    if (!this.propertyDamage || !this.propertyDamageNote) return

    let value = this.propertyDamage.value;
    if (value === 'MINOR_DAMAGE' || value === 'MAJOR_DAMAGE') {
      showBlock(this.propertyDamageNoteDiv);
      this.propertyDamageNote.required = true;
    } else {
      hide(this.propertyDamageNoteDiv);
      this.propertyDamageNote.required = false;
    }
  }

  syncFormWithEvictionFiled() {
    if (!this.evictionFiled) return


    let value = this.evictionFiled.value;
    if (!this.evictionContext) return

    if (value === 'true') {
      showBlock(this.evictionContextDiv);
      this.evictionContext.required = true;
    } else {
      hide(this.evictionContextDiv);
      this.evictionContext.required = false;
    }
  }

  syncFormWithEvictionJudgment() {
    if (!this.evictionJudgment) return

    let value = this.evictionJudgment.value;
    if (!this.evictionJudgmentDateDiv) return

    if (value === 'true') {
      showBlock(this.evictionJudgmentDateDiv);
    } else {
      hide(this.evictionJudgmentDateDiv);
    }
  }
}
